import newApi from '../new-api';
export const apiServer = {
  getDataByType(type, apiMethod, params, callback) {
    // console.info("[DEBUG] apiServer.getDataByType called with:", { type, apiMethod, params })
    
    let types = ['spec', 'sds', 'coa']
    if (!types.includes(type)) {
      throw new Error('Invalid type');
    }
    let language = 'EN';
    let pathLanguage = localStorage.getItem('language');
    if(typeof(pathLanguage)!='undefined'){
      language = localStorage.getItem('language').toUpperCase()
    }

    if (typeof callback !== 'function') {
      throw new Error('Callback must be a function');
    }
    if (language == 'ZH') {
      language = 'CN'
    }

    // console.info("[DEBUG] Using language:", language)

    const apiMap = {
      EN: {
        spec: 'enSpecServer',
        sds: 'enSdsServer',
        coa: 'enCoaServer'
      },
      CN: {
        spec: 'cnSpecServer',
        sds: 'cnSdsServer',
        coa: 'cnCoaServer'
      }
    };

    const apiServer = apiMap[language]?.[type];
    // console.info("[DEBUG] Selected apiServer:", apiServer)

    if (!apiServer) {
      throw new Error(`Invalid language or type: ${language}, ${type}`);
    }

    // console.info("[DEBUG] API method exists:", typeof newApi[apiServer]?.[apiMethod])
    const apiCall = newApi[apiServer][apiMethod](params);
    // console.info("[DEBUG] API call created, making request...");

    // 返回Promise以支持链式调用
    return apiCall.then(data => {
      // console.info('getDataByType data:',data)
      callback(data);
      return data; // 返回数据供链式调用使用
    })
    .catch(err => {
      console.error('API调用错误:', err);
      // 调用回调函数传递错误信息
      callback({ success: false, message: err.message || '网络请求失败' });
      throw err; // 重新抛出错误以供.catch()处理
    });
  },
  isAdminAuth(username) {
    return !!(
      username === "JamesChen" ||
      username === "admin" ||
      username === "JiaZhang"
    );
  }
}
